import type { PromptResponse } from '../types/promptGallery.types';

/**
 * Mock prompt data for development and testing
 * This data will be replaced with real API calls when backend is ready
 */
export const mockPrompts: PromptResponse = {
    prompts: [
        // Search Prompts
        {
            id: 'prompt-1',
            name: 'Show Actions assigned to me',
            category: 'Search',
            template: 'Show Actions assigned to me',
            sortOrder: 1,
        },
        {
            id: 'prompt-2',
            name: 'What actions are assigned to person?',
            category: 'Search',
            template: 'What actions are assigned to <Entity type="person">Person</Entity>?',
            sortOrder: 2,
        },
        {
            id: 'prompt-2',
            name: 'Get actions are assigned to person?',
            category: 'Search',
            template: 'Get actions are assigned to< Entity type="person" > Person </Entity>?',
            sortOrder: 2,
        },
        {
            id: 'prompt-3',
            name: 'Open Action',
            category: 'Search',
            template: 'Open Action <Entity type="action">Action</Entity>',
            sortOrder: 3,
        },

        // Summarize Prompts
        {
            id: 'prompt-10',
            name: 'Summarize Action',
            category: 'Summarize',
            template: 'Summarize Action <Entity type="action">Action</Entity>',
            sortOrder: 10,
        },
        {
            id: 'prompt-11',
            name: 'Summarize Actions for TPID',
            category: 'Summarize',
            template: 'Summarize Actions for TPID 2143378',
            sortOrder: 11,
        },
        {
            id: 'prompt-12',
            name: 'Summary of issues for Toyota',
            category: 'Summarize',
            template: 'Provide a summary of issues for Toyota Motor Sales as a bulleted list',
            sortOrder: 12,
        },
        {
            id: 'prompt-13',
            name: 'Summarize issues for Walgreens',
            category: 'Summarize',
            template: 'Summarize issues for Walgreens',
            sortOrder: 13,
        },
        {
            id: 'prompt-14',
            name: 'Summarize security issues',
            category: 'Summarize',
            template: 'Summarize security issues with details',
            sortOrder: 14,
        },
        {
            id: 'prompt-15',
            name: 'Microsoft Investments summary',
            category: 'Summarize',
            template: 'Summarize all Microsoft Investments related issues',
            sortOrder: 15,
        },
        {
            id: 'prompt-16',
            name: 'Summarize recent escalations',
            category: 'Summarize',
            template: 'Summarize recent escalations and their status',
            sortOrder: 16,
        },

        // Analyze Prompts
        {
            id: 'prompt-20',
            name: 'Azure Capacity issues',
            category: 'Analyze',
            template: 'Who are the customers experiencing issues with Azure Capacity?5 Please include details.',
            sortOrder: 20,
        },
        {
            id: 'prompt-21',
            name: 'SAP Azure Capacity issues',
            category: 'Analyze',
            template: 'Who are the SAP customers experiencing issues with Azure Capacity, include issue details?',
            sortOrder: 21,
        },
        {
            id: 'prompt-22',
            name: 'Power BI renewal risk',
            category: 'Analyze',
            template: 'Who are the Power BI customers at renewal risk? Please include reasons and details.',
            sortOrder: 22,
        },
        {
            id: 'prompt-23',
            name: 'ECIF requests',
            category: 'Analyze',
            template: 'Who are the customers requesting ECIF? Please include request details.',
            sortOrder: 23,
        },
        {
            id: 'prompt-24',
            name: 'Linux escalations',
            category: 'Analyze',
            template: 'Can you provide information on any customer escalations related to Linux, including the customer name and impact details?',
            sortOrder: 24,
        },
        {
            id: 'prompt-25',
            name: 'Teams escalations',
            category: 'Analyze',
            template: 'What are the customers escalated issues with Microsoft Teams? Please provide issue details as bullet points.',
            sortOrder: 25,
        },
        {
            id: 'prompt-26',
            name: 'Value Based Deliverable guidance',
            category: 'Analyze',
            template: 'What is a Value Based Deliverable? Provide more details on how to use VBDs',
            sortOrder: 26,
        },

        // Track Prompts
        {
            id: 'prompt-30',
            name: 'High priority actions',
            category: 'Track',
            template: 'Show me high priority actions that need attention',
            sortOrder: 30,
        },
        {
            id: 'prompt-31',
            name: 'Action types',
            category: 'Track',
            template: 'What types of actions are being tracked in this dataset?',
            sortOrder: 31,
        },
        {
            id: 'prompt-32',
            name: 'Revenue tracking',
            category: 'Track',
            template: 'How are revenue impacts associated with specific tasks or actions tracked?',
            sortOrder: 32,
        },
    ],
};
